import React, { useContext } from 'react'
import { Context, Provider } from './Context'
import HTag from 'components/common/HTag'
import HexPatternSection from 'components/common/HexPatternSection'
import BlueprintGraphic from 'components/BlueprintGraphic'
import Employee from './Employee'
import EmployeeDetails from './EmployeeDetails'
import clsx from 'clsx'
import * as css from './index.module.css'

const App = ({ heading }) => {
  const { employees, $active } = useContext(Context)

  const employee = employees.find(employee => employee._id === $active) || {}

  return (
    <section className="relative py-16">
      <header className="ctnr padding-x">
        <HTag {...heading} />
      </header>

      <HexPatternSection style={{ '--top': 0 }}>
        <ul className={clsx(css.list, 'ctnr padding-x')}>
          {employees?.map((employee, key) => (
            <Employee {...employee} key={key} />
          ))}
        </ul>

        <BlueprintGraphic style={{ bottom: 0, right: 0 }} />
      </HexPatternSection>

      {!!$active && <EmployeeDetails {...employee} />}
    </section>
  )
}

const EmployeeList = props => <Provider children={<App {...props} /> } />

export default EmployeeList
